import React from 'react';
import logo from './logo.svg';
import HeaderPayment from './payment';
import { locationPath } from '../../helpers/locationHelper';

const Header = (props) => {
  return (
    <div className={`header ${locationPath()}`}>
      <div className="row">
        <div className="column small-12 large-11 large-offset-0-5">
          <div className="row">
                <div className="column small-6">
                    <a href="https://www.busabout.com"><img src={logo} alt="Busabout Logo" className="logo"/></a>
                </div>
                <div className="column small-6">
                    <HeaderPayment location={locationPath()}/>
                </div>
              </div>
          </div>
      </div>
    </div>
  )
}

export default React.memo(Header);


// WEBPACK FOOTER //
// ./src/components/shared/header.js